import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-67211f26")

_pushScopeId("data-v-67211f26")
const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确 定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_alert = _resolveComponent("el-alert")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "强制关闭授权",
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.visible = $event)),
    width: "500px",
    onClosed: _ctx.onClosed
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, { onClick: _ctx.handleCancel }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleSubmit
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_el_alert, {
        title: "将按 公司 + 合同编号 + 业务类型 批量关闭名下全部生效授权，关闭后立即失效且不可恢复，请谨慎操作！",
        type: "warning",
        "show-icon": "",
        closable: false,
        class: "mb20"
      }),
      _createVNode(_component_el_form, {
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.formData,
        "label-width": "130px",
        style: {"max-width":"500px"}
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: "所属公司:",
            prop: "companyUuid"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.companyUuid,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.companyUuid = $event)),
                "remote-method": _ctx.remoteData1.remoteMethod,
                remote: "",
                placeholder: "请输入",
                clearable: "",
                filterable: "",
                style: {"width":"200px"}
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.remoteData1.options, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "合同编号:",
            prop: "externalContractNo"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.externalContractNo,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.externalContractNo = $event)),
                maxlength: 64,
                "show-word-limit": "",
                placeholder: "请输入",
                style: {"width":"200px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "业务类型:",
            prop: "businessType"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.businessType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.businessType = $event)),
                placeholder: "请选择",
                style: {"width":"200px"}
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_option, {
                    label: "备案",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "转移",
                    value: 2
                  }),
                  _createVNode(_component_el_option, {
                    label: "查看违章",
                    value: 3
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed"]))
})